var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEngage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,1.25 C28,0.557291667 27.401484,0 26.6575342,0 C25.9135845,0 25.3150685,0.557291667 25.3150685,1.25 L25.3150685,18.75 C25.3150685,19.4427083 25.9135845,20 26.6575342,20 C27.401484,20 28,19.4427083 28,18.75 L28,1.25 Z M20.7086335,10.7067982 C21.2249761,10.2170045 21.2249761,9.42499763 20.7086335,8.94041449 L13.238145,1.84882677 C12.7218024,1.35903305 11.8868655,1.35903305 11.3760159,1.84882677 C10.8651663,2.33862048 10.8596733,3.13062734 11.3760159,3.61521048 L16.5943718,8.56525335 L1.31832149,8.56525335 C0.587751666,8.56525335 0,9.12278449 0,9.81579049 C0,10.5087965 0.587751666,11.0663276 1.31832149,11.0663276 L16.5943718,11.0663276 L11.3760159,16.0163705 C10.8596733,16.5061642 10.8596733,17.2981711 11.3760159,17.7827542 C11.8923585,18.2673374 12.7272954,18.2725479 13.238145,17.7827542 L20.7086335,10.7067982 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngage);
export default __webpack_public_path__ + "static/media/engage.29f59ace58f2cfd1ee4f29ef82e04463.svg";
export { ForwardRef as ReactComponent };